import { getMUserPins } from "@/services";
import { checkCanUploadPin } from "@/utils/open";
import { useMount, useSafeState, useUpdateEffect } from "ahooks";
import { useCallback, useMemo } from "react";
import HBIcon from "../../HBIcon";
import HBMessage from "../../HBMessage";
import PinList from "../../PinList";
import styles from "../index.module.less";
import Empty from "./Empty";
import Loading from "./Loading";
import TabPanel from "./TabPanel";

export default function MusePinListPanel({ user, isMe, initMusePins }) {
  const [records, setRecords] = useSafeState(initMusePins || []);
  const [hasMore, setHasMore] = useSafeState(true);
  const [loading, setLoading] = useSafeState(!initMusePins);

  const loadData = useCallback(
    async (currentRecords) => {
      setLoading(true);
      currentRecords = currentRecords || records;
      const PAGE_SIZE = 30;
      const params = {
        username: user.urlname,
        max: currentRecords[currentRecords.length - 1]?.pin_id,
        limit: PAGE_SIZE,
      };
      const { err, pins } = await getMUserPins(params);
      setLoading(false);
      if (err) return;

      if (pins.length < PAGE_SIZE) setHasMore(false);

      const _pins = pins
        .filter((e) => !!e)
        .map(({ pin, ...rest }) => ({
          ...rest,
          ...pin,
        }));
      setRecords([...currentRecords.concat(_pins)]);
    },
    [records, setHasMore, setLoading, setRecords, user.urlname]
  );

  const onCreateClick = useCallback(async () => {
    if (!checkCanUploadPin(user)) {
      return;
    }

    const { PinUploaderModal } = await import("../../PinCreator");

    PinUploaderModal.open({
      name: "pinUploaderModal",
      onlyCreation: true,
      onOk: async () => {
        HBMessage.success("添加成功");
        await loadData([]);
      },
    });
  }, [loadData, user]);

  useUpdateEffect(() => {
    if (!initMusePins || !initMusePins.length) {
      loadData([]);
    }
  }, []);

  useMount(async () => loadData([]));

  const createBtn = useMemo(
    () => (
      <div
        className={styles.createRect}
        key={"createBtn"}
        onClick={onCreateClick}
        data-gd-click="button_click"
        data-button-name="上传原创"
        title="上传原创"
      >
        <div className={styles.block}>
          <HBIcon type={"plus"} className={styles.icon} />
        </div>
      </div>
    ),
    [onCreateClick]
  );

  if (loading && !records.length) {
    return <Loading />;
  }

  return (
    <TabPanel>
      <div style={{ marginTop: "32px" }}>
        {!records.length ? (
          isMe ? (
            createBtn
          ) : (
            <Empty
              imageUrl={
                "https://cdn.dancf.com/fe-assets/img/e66686c56220ce789c966b6653936017.png"
              }
              title={"还没有原创采集哦～"}
            />
          )
        ) : (
          <PinList
            dataSource={records}
            onLoadMore={loadData}
            hasMore={hasMore}
            hideUser
          >
            {isMe ? createBtn : null}
          </PinList>
        )}
      </div>
    </TabPanel>
  );
}
